/**
 * Load Google base event listeners
 */

// Pixel load event listener
pmw.bus.on("pmw:load-pixels", function () {

	if (typeof pmwDataLayer?.pixels?.google?.state === "undefined") {
		if (pmw.googleConfigConditionsMet({log: true})) {
			pmw.loadGoogle()
		} else {
			pmw.consent.logSuppressedPixel("statistics", "Google Analytics / Google Ads")
		}
	}
})

document.addEventListener("pmw:consent:update", ({detail}) => {

	const consent = detail

	pmw.updateGoogleConsentMode(consent)
}, true)
